import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  standalone: true,
  selector: 'app-heads-up',
  templateUrl: './heads-up.component.html',
  styleUrls: ['./heads-up.component.scss'],
  imports: [CommonModule, RouterModule]
})
export class HeadsUpComponent implements OnInit {
  @Input() current: number | null = 0;
  @Input() currentMontlhy: number | null = 0;
  @Input() maxMonthly: number | null = 0;
  @Input() currentCartPrice: number | null = 0;
  @Input() currency: string | null = 'GBP';
  @Output() maxMonthlyReached = new EventEmitter<boolean>();

  treshHoldMax: number | null = null;
  trashHoldNormal: number | null = 10;

  ngOnInit(): void {
    this.treshHoldMax = Math.floor(this.maxMonthly / 3);
  }

  defineOrder(id: number) {
    if (
      this.maxMonthly &&
      this.currentMontlhy >= this.treshHoldMax &&
      this.currentMontlhy + Number(this.currentCartPrice) < this.maxMonthly
    ) {
      return id == 1;
    } else if (
      this.maxMonthly &&
      Number(this.currentMontlhy) + Number(this.currentCartPrice) >
        Number(this.maxMonthly) &&
      Number(this.currentCartPrice) > 0
    ) {
      return id == 2;
    } else if (this.trashHoldNormal && this.current >= this.trashHoldNormal) {
      return id == 3;
    }
    return false;
  }
}
